import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component } from '@eastsideco/salvo-ts';

@Component
export class CartFeature extends ThemeComponent {}
